export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/ios_android_dual.5671253.svg";